"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function ContactCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="231390" id="unisciti-al-ricordo" className="bg-background text-foreground relative overflow-hidden">
            {}
            <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-primary/10 to-background pointer-events-none" />

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

            <div className="relative z-10 container mx-auto px-4 py-48 flex flex-col items-center justify-center text-center">
                <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold uppercase tracking-widest text-foreground mb-16 max-w-5xl leading-tight drop-shadow-sm">
                    Onora la Memoria tra le Vette
                </h2>

                <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-12 scale-95"}`}>
                    {}
                    <div className={isVisible ? "animate-pulse" : ""}>
                        <Button asChild size="lg" className="rounded-none border-b-2 border-primary bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground shadow-none backdrop-blur-none transition-all duration-500 h-16 px-10 text-lg tracking-widest uppercase group">
                            <Link to="#">
                                Condividi una Storia
                                <ArrowRight className="ml-3 size-5 transition-transform group-hover:translate-x-1" />
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>;
}